import { ColorPicker, Layout, Menu, Modal, Row, Col, Checkbox, Carousel, Upload, Card, ConfigProvider, Tabs, Typography, message } from 'antd';
import React, { useEffect, useState, useRef, useContext } from 'react';
import styled from 'styled-components';
import ShareLearningModal from './ShareLearningModal';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { EditOutlined, ArrowRightOutlined, PlusOutlined } from '@ant-design/icons';
import axios from 'axios';
import Label_language from '../../language';
import AdminModal from "./AdminModal";
const { Title, Paragraph, Text, Link } = Typography;
const TitleModal = (props) => {
    useEffect(() => {
        // if (JSON.stringify(props.editcard) != '{}') {
        //     set_blog_id(props.editcard.blog_id);
        //     // get_picture();

        // } else {
        //     props.setEditCard({ file_id: [], file_url: [] });
        //     set_blog_id('');
        // }
        // console.log(props.editcard);
    }, [props.editcard])
    return (<>
        <AdminModal
            {...props}
            title={(<>
                <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 50, left: 28 }} >{props.title}標題</Col>
            </>)}
            uploads
        >
            <Row gutter={[10, 10]}>
                <Col span={6}>顏色</Col>
                <Col span={18}>
                    <Row gutter={[8, 8]}>
                        <Col>左邊顏色：</Col>
                        <Col>
                            <ColorPicker
                                format={'hex'}
                                value={props.editcard.background_color1}
                                onChange={color =>
                                    props.setEditCard((pre) => {
                                        return (
                                            {
                                                ...pre,
                                                background_color1: `#${color.metaColor.toHex()}`,
                                            }
                                        )
                                    })
                                }></ColorPicker>
                        </Col>
                        <Col>右邊顏色：</Col>
                        <Col>
                            <ColorPicker
                                format={'hex'}
                                value={props.editcard.background_color2}
                                onChange={color =>
                                    props.setEditCard((pre) => {
                                        return (
                                            {
                                                ...pre,
                                                background_color2: `#${color.metaColor.toHex()}`,
                                            }
                                        )
                                    })
                                }></ColorPicker>
                        </Col>
                    </Row>
                </Col>
                <Col span={24}>
                    <Row justify={'center'} align="middle" style={{ backgroundImage: `linear-gradient(to right, ${props.editcard.background_color1}, #ffffff, ${props.editcard.background_color2})`, padding: '10px', position: 'relative' }}>
                        <Col>
                            <Col style={{ textAlign: 'center' }}>
                                <span style={{ fontSize: '2rem' }}>{props.name}</span>
                            </Col>
                        </Col >
                    </Row>
                </Col>
                <Col span={6}></Col>
                <Col span={18}>
                    <Checkbox
                        checked={props.editcard.color_show == 1 ? true : false}
                        onChange={e => props.setEditCard((pre) => {
                            return (
                                {
                                    ...pre,
                                    color_show: e.target.checked,
                                }
                            )
                        })}
                    >顯示在此頁</Checkbox>
                </Col>
            </Row>
        </AdminModal>
    </>)
}
export default TitleModal;